import KineduAuth from 'kinedu-auth';
import { ENV, IS_LOCALHOST, CLIENT_API_URL } from 'config';
import { APP_SECTIONS_PATHS } from 'constants/routes';
import { AppEvents, EventProviders } from 'constants/events';
import EventReporter from 'appEvents';

const { API } = KineduAuth;
const { logout } = API(ENV, CLIENT_API_URL);

// eslint-disable-next-line import/prefer-default-export
export const handleLogOut = () => {
  const token = localStorage.getItem('auth_token') || '';
  const email = localStorage.getItem('user_email') || '';
  localStorage.clear();

  EventReporter.action(AppEvents.LOG_OUT(), [EventProviders.MIXPANEL]);

  if (!IS_LOCALHOST) {
    window.location.assign(window.location.origin);
  } else {
    window.location.assign(APP_SECTIONS_PATHS.SIGNIN);
  }
  logout(token, email)
    .then(() => {
      localStorage.clear();
      window.KineduCalendarApi.destroy();
    })
    .catch((err: any) => {
      console.error(
        '%c🚫 err in logout',
        'background: #a20300; color: #ffa8a6; font-size: 16px',
        err,
      );
    });
};
